import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { ColumnType } from 'antd/lib/table';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Text03 } from 'components/styles';

type StatusFieldData = {
  jiraStatusName: string;
  rlStatusname: string;
};

const RlField = styled.p`
  ${Text03};
  margin-bottom: 0;
`;

export const columns: ColumnType<StatusFieldData>[] = [
  {
    title: (
      <FormattedMessage id="settings.integrations.jira.table.status_category" />
    ),
    dataIndex: 'jiraField',
    width: 400,
  },
  {
    key: 'arrow',
    render: () => <ArrowRight16 />,
    width: 16,
  },
  {
    title: <FormattedMessage id="settings.integrations.jira.table.rl_field" />,
    dataIndex: 'rlField',
    render: (fieldName) => <RlField>{fieldName}</RlField>,
  },
];
